import Cocoon from '@nathanvda/cocoon';

$(function() {
  $('.card').on('cocoon:after-insert cocoon:after-remove', function() {
    check_to_hide_or_show_add_link();
  });

  check_to_hide_or_show_add_link();

  function check_to_hide_or_show_add_link() {
    if ($('.card .nested-fields').length == 4) {
      $('a.btn-success.add_fields').hide();
    } else {
      $('a.btn-success.add_fields').show();
    }
  }
})